export default __webpack_public_path__ + "static/media/17.6c3ed459.jpeg";